import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useCallback } from 'react';
import { View, Text, TextInput } from 'react-native';
import styled from 'styled-components/native';
import SccRemoteImage from '@/components/SccRemoteImage';
import { color } from '@/constant/color';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import HtmlContentWrapper from '../components/HtmlContentWrapper';
import ImageUploader from '../components/ImageUploader';
import InteractiveImage from '../components/InteractiveImage';
import { useEditMode } from '../context/EditModeContext';
import { useResponsive } from '../context/ResponsiveContext';
export default function SeatViewSection({ seatViewSection, sectionId, }) {
    var _a, _b;
    const editContext = useEditMode();
    const isEditMode = (_a = editContext === null || editContext === void 0 ? void 0 : editContext.isEditMode) !== null && _a !== void 0 ? _a : false;
    const { isDesktop } = useResponsive();
    const { titleLine1, titleLine2, descriptionHtmls, interactiveImage, mobileImageUrl, noticeBox } = seatViewSection;
    const updateSeatViewSection = useCallback((updates) => {
        if (!editContext)
            return;
        editContext.updateData((prev) => (Object.assign(Object.assign({}, prev), { seatViewSection: prev.seatViewSection
                ? Object.assign(Object.assign({}, prev.seatViewSection), updates) : null })));
    }, [editContext]);
    const handleTitleLine1Change = useCallback((text) => {
        updateSeatViewSection({ titleLine1: text });
    }, [updateSeatViewSection]);
    const handleTitleLine2Change = useCallback((text) => {
        updateSeatViewSection({ titleLine2: text });
    }, [updateSeatViewSection]);
    const handleInteractiveImageChange = useCallback((url) => {
        updateSeatViewSection({
            interactiveImage: {
                url,
                clickableRegions: (interactiveImage === null || interactiveImage === void 0 ? void 0 : interactiveImage.clickableRegions) || [],
            },
        });
    }, [interactiveImage, updateSeatViewSection]);
    const handleMobileImageChange = useCallback((url) => {
        updateSeatViewSection({ mobileImageUrl: url });
    }, [updateSeatViewSection]);
    // 모바일 + 정적 이미지용: 모든 region의 modalImageUrls를 하나의 배열로 합침 (모바일 URL 우선)
    const allModalImages = ((_b = interactiveImage === null || interactiveImage === void 0 ? void 0 : interactiveImage.clickableRegions) === null || _b === void 0 ? void 0 : _b.flatMap((region) => {
        var _a;
        return ((_a = region.mobileModalImageUrls) === null || _a === void 0 ? void 0 : _a.length)
            ? region.mobileModalImageUrls
            : region.modalImageUrls || [];
    })) || [];
    return (_jsx(LogParamsProvider, { params: { displaySectionName: '시야정보' }, children: _jsx("div", { id: sectionId, children: _jsx(Container, { isDesktop: isDesktop, children: _jsxs(ContentWrapper, { isDesktop: isDesktop, children: [_jsx(TitleSection, { children: isEditMode ? (_jsxs(_Fragment, { children: [_jsx(TitleLine1Input, { value: titleLine1, onChangeText: handleTitleLine1Change, placeholder: "\uD0C0\uC774\uD2C0 1\uC904 (\uAC80\uC815)", placeholderTextColor: color.gray40, isDesktop: isDesktop }), _jsx(TitleLine2Input, { value: titleLine2, onChangeText: handleTitleLine2Change, placeholder: "\uD0C0\uC774\uD2C0 2\uC904 (\uD30C\uB791)", placeholderTextColor: color.gray40, isDesktop: isDesktop })] })) : (_jsxs(_Fragment, { children: [_jsx(TitleLine1, { isDesktop: isDesktop, children: titleLine1 }), _jsx(TitleLine2, { isDesktop: isDesktop, children: titleLine2 })] })) }), !isDesktop && mobileImageUrl ? (_jsxs(ImageContainer, { isDesktop: isDesktop, children: [_jsx(SccRemoteImage, { imageUrl: mobileImageUrl, resizeMode: "contain", wrapperBackgroundColor: null }), noticeBox && (_jsxs(NoticeBoxContainer, { isDesktop: isDesktop, children: [_jsxs(NoticeBoxTitleRow, { children: [noticeBox.title.startsWith('📢') && (_jsx(NoticeBoxEmoji, { children: "\uD83D\uDCE2" })), _jsx(NoticeBoxTitle, { children: noticeBox.title.startsWith('📢') ? noticeBox.title.slice(2).trim() : noticeBox.title })] }), _jsx(NoticeBoxDescription, { children: _jsx(HtmlContentWrapper, { isDesktop: isDesktop, children: _jsx("div", { dangerouslySetInnerHTML: { __html: noticeBox.descriptionHtml } }) }) })] })), isEditMode && (_jsx(MobileImageOverlay, { children: _jsx(ImageUploader, { currentImageUrl: mobileImageUrl, onUploadComplete: handleMobileImageChange, compact: true }) }))] })) : (interactiveImage === null || interactiveImage === void 0 ? void 0 : interactiveImage.url) ? (_jsxs(ImageContainer, { isDesktop: isDesktop, children: [_jsx(ImageFrameWrapper, { isDesktop: isDesktop, children: _jsx(InteractiveImage, { interactiveImage: interactiveImage, onImageChange: isEditMode ? handleInteractiveImageChange : undefined, routeIndex: 0, sectionType: "seatView", hintTextBackgroundColor: color.brand5 }) }), noticeBox && (_jsxs(NoticeBoxContainer, { isDesktop: isDesktop, children: [_jsxs(NoticeBoxTitleRow, { children: [noticeBox.title.startsWith('📢') && (_jsx(NoticeBoxEmoji, { children: "\uD83D\uDCE2" })), _jsx(NoticeBoxTitle, { children: noticeBox.title.startsWith('📢') ? noticeBox.title.slice(2).trim() : noticeBox.title })] }), _jsx(NoticeBoxDescription, { children: _jsx(HtmlContentWrapper, { isDesktop: isDesktop, children: _jsx("div", { dangerouslySetInnerHTML: { __html: noticeBox.descriptionHtml } }) }) })] }))] })) : (isEditMode && (_jsxs(EmptyImagePlaceholder, { children: [_jsx(EmptyImageText, { children: "\uACBD\uAE30\uC7A5 \uC9C0\uB3C4 \uC774\uBBF8\uC9C0\uB97C \uC5C5\uB85C\uB4DC\uD558\uC138\uC694" }), _jsx(ImageUploader, { onUploadComplete: handleInteractiveImageChange, buttonText: "\uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" })] }))), isEditMode && isDesktop && (_jsxs(MobileImageSection, { children: [_jsx(MobileImageLabel, { children: "\uBAA8\uBC14\uC77C\uC6A9 \uC774\uBBF8\uC9C0 (\uC120\uD0DD\uC0AC\uD56D)" }), mobileImageUrl ? (_jsxs(MobileImagePreview, { children: [_jsx(SccRemoteImage, { imageUrl: mobileImageUrl, resizeMode: "contain", style: { borderRadius: 8, maxHeight: 200 }, wrapperBackgroundColor: null }), _jsx(MobileImageActions, { children: _jsx(ImageUploader, { currentImageUrl: mobileImageUrl, onUploadComplete: handleMobileImageChange, compact: true }) })] })) : (_jsx(ImageUploader, { onUploadComplete: handleMobileImageChange, buttonText: "\uBAA8\uBC14\uC77C \uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" }))] })), descriptionHtmls && descriptionHtmls.length > 0 && (_jsx(DescriptionGrid, { isDesktop: isDesktop, children: descriptionHtmls.map((html, index) => (_jsx(DescriptionItem, { isDesktop: isDesktop, children: _jsx(HtmlContentWrapper, { isDesktop: isDesktop, children: _jsx("div", { dangerouslySetInnerHTML: { __html: html } }) }) }, index))) })), !isDesktop && mobileImageUrl && allModalImages.length > 0 && (_jsx(RegionImagesContainer, { children: allModalImages.map((imageUrl, index) => (_jsx(RegionImageWrapper, { children: _jsx(SccRemoteImage, { imageUrl: imageUrl, resizeMode: "contain", style: { borderRadius: 8 }, wrapperBackgroundColor: null }) }, index))) }))] }) }) }) }));
}
const Container = styled(View) `
  padding-vertical: ${({ isDesktop }) => (isDesktop ? '140px' : '80px')};
  width: 100%;
`;
const ContentWrapper = styled(View) `
  align-items: center;
  gap: ${({ isDesktop }) => (isDesktop ? '60px' : '32px')};
  width: 100%;
  padding: 0 16px;
`;
const TitleSection = styled(View) `
  align-items: center;
  gap: 0;
  max-width: 800px;
  width: 100%;
  padding: 0 16px;
`;
const TitleLine1 = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '36px' : '24px')};
  font-weight: 700;
  color: ${color.black};
  text-align: center;
  line-height: ${({ isDesktop }) => (isDesktop ? '48px' : '34px')};
`;
const TitleLine2 = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '36px' : '24px')};
  font-weight: 700;
  color: #0e64d3;
  text-align: center;
  line-height: ${({ isDesktop }) => (isDesktop ? '48px' : '34px')};
`;
const TitleLine1Input = styled(TextInput) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '40px' : '24px')};
  font-weight: 700;
  color: ${color.black};
  text-align: center;
  width: 100%;
`;
const TitleLine2Input = styled(TextInput) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '40px' : '24px')};
  font-weight: 700;
  color: #0e64d3;
  text-align: center;
  width: 100%;
`;
const DescriptionGrid = styled(View) `
  flex-direction: ${({ isDesktop }) => (isDesktop ? 'row' : 'column')};
  flex-wrap: wrap;
  gap: ${({ isDesktop }) => (isDesktop ? '60px' : '32px')};
  max-width: 1020px;
  width: 100%;
  /* Figma: Image+noticeBox와 DescriptionGrid 사이 gap은 30px (ContentWrapper gap 60px - 30px) */
  margin-top: ${({ isDesktop }) => (isDesktop ? '-30px' : '0')};
`;
const DescriptionItem = styled(View) `
  flex: 1;
  flex-basis: ${({ isDesktop }) => (isDesktop ? '45%' : '100%')};
  width: ${({ isDesktop }) => (isDesktop ? 'auto' : '100%')};
`;
const ImageContainer = styled(View) `
  max-width: 1020px;
  width: ${({ isDesktop }) => (isDesktop ? '100%' : 'calc(100% + 32px)')};
  margin-horizontal: ${({ isDesktop }) => (isDesktop ? '0' : '-16px')};
  position: relative;
`;
/* Figma 디자인: 이미지 프레임 고정 높이 630px, overflow-clip */
const ImageFrameWrapper = styled(View) `
  width: 100%;
  ${({ isDesktop }) => isDesktop && `
    max-height: 630px;
    overflow: hidden;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: #f7f8fa;
  `}
`;
const EmptyImagePlaceholder = styled(View) `
  max-width: 1020px;
  width: 100%;
  padding: 60px;
  background-color: ${color.white};
  border: 2px dashed ${color.gray25};
  border-radius: 12px;
  align-items: center;
  gap: 16px;
`;
const EmptyImageText = styled(Text) `
  font-size: 16px;
  color: ${color.gray60};
`;
/* 모바일: Region 이미지 직접 표시 */
const RegionImagesContainer = styled(View) `
  width: 100%;
  margin-horizontal: 16px;
  gap: 12px;
`;
const RegionImageWrapper = styled(View) `
  width: 100%;
  overflow: hidden;
`;
/* 모바일 이미지 오버레이 (Edit Mode) */
const MobileImageOverlay = styled(View) `
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
`;
/* 모바일 이미지 관리 섹션 (데스크탑 Edit Mode) */
const MobileImageSection = styled(View) `
  max-width: 1020px;
  width: 100%;
  padding: 20px;
  background-color: ${color.gray10};
  border-radius: 12px;
  gap: 12px;
`;
const MobileImageLabel = styled(Text) `
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;
  color: ${color.gray80};
`;
const MobileImagePreview = styled(View) `
  position: relative;
  max-width: 400px;
`;
const MobileImageActions = styled(View) `
  position: absolute;
  top: 8px;
  right: 8px;
`;
/* 제보 알림 박스 */
const NoticeBoxContainer = styled(View) `
  max-width: 1020px;
  margin-top: ${({ isDesktop }) => (isDesktop ? '12px' : '0')};
  background-color: rgba(184, 255, 85, 0.3);
  border-radius: ${({ isDesktop }) => (isDesktop ? '12px' : '0')};
  padding: 16px;
  gap: 6px;
`;
const NoticeBoxTitleRow = styled(View) `
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
const NoticeBoxEmoji = styled(Text) `
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  color: ${color.brand50};
`;
const NoticeBoxTitle = styled(Text) `
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  color: ${color.black};
`;
const NoticeBoxDescription = styled(View) `
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 400;
  color: ${color.gray80};
  line-height: 24px;
`;
